
document.addEventListener("DOMContentLoaded", function () {
    const observerOptions = {
        root: null,
        threshold: 0.5
    };

    function animateNumber(element, target) {
        let start = 0;
        const duration = 1000;
        const step = (timestamp) => {
            if (!element.startTime) element.startTime = timestamp;
            const progress = timestamp - element.startTime;
            const current = Math.min(Math.floor((progress / duration) * target), target);
            element.innerText = `${current}%`;
            if (current < target) {
                requestAnimationFrame(step);
            } else {
                element.startTime = null;
            }
        };
        requestAnimationFrame(step);
    }


    const sectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const numbers = document.querySelectorAll(".mm-advantages__number");
                numbers.forEach(numberElement => {
                    const target = parseInt(numberElement.getAttribute("data-target"), 10);
                    animateNumber(numberElement, target);
                });
            }
        });
    }, observerOptions);


    const advantagesSection = document.getElementById("mm-advantages");
    if (advantagesSection) {
        sectionObserver.observe(advantagesSection);
    }
});
